(function () {
  'use strict';

  var SELECTORS = {
    drawer: '[data-pm-drawer]',
    overlay: '[data-pm-drawer-overlay]'
  };

  function all(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function focusable(container) {
    return all('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', container)
      .filter(function (item) { return item.offsetParent !== null; });
  }

  function trapTab(event, container) {
    if (event.key !== 'Tab' || !container) return;
    var items = focusable(container);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function syncBodyLock() {
    var hasOpenPanel = document.querySelector(SELECTORS.drawer + '.is-open, .js-box-search.active, .js-minicart.active');
    document.body.classList.toggle('pm-drawer-open', Boolean(hasOpenPanel));
  }

  function setDrawerState(drawer, open, trigger) {
    if (!drawer) return;
    var overlay = document.querySelector(SELECTORS.overlay);
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) drawer.removeAttribute('inert');
    else drawer.setAttribute('inert', '');
    if (overlay) overlay.classList.toggle('is-open', open);
    if (drawer.id) {
      all('[aria-controls="' + drawer.id + '"]').forEach(function (control) {
        control.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    syncBodyLock();

    if (open) {
      drawer.dataset.pmReturnFocus = trigger && trigger.id ? trigger.id : '';
      var items = focusable(drawer);
      if (items.length) items[0].focus();
    } else {
      var returnFocus = drawer.dataset.pmReturnFocus && document.getElementById(drawer.dataset.pmReturnFocus);
      if (returnFocus) returnFocus.focus();
    }
  }

  function closeAllDrawers() {
    all(SELECTORS.drawer + '.is-open').forEach(function (drawer) {
      setDrawerState(drawer, false);
    });
  }

  function initDrawers(context) {
    all('[data-pm-drawer-open]', context).forEach(function (trigger) {
      if (trigger.dataset.pmBound) return;
      trigger.dataset.pmBound = 'true';
      trigger.addEventListener('click', function () {
        var drawer = document.getElementById(trigger.getAttribute('aria-controls'));
        closeAllDrawers();
        setDrawerState(drawer, true, trigger);
      });
    });

    all('[data-pm-drawer-close]', context).forEach(function (trigger) {
      if (trigger.dataset.pmBound) return;
      trigger.dataset.pmBound = 'true';
      trigger.addEventListener('click', function () {
        setDrawerState(trigger.closest(SELECTORS.drawer), false);
      });
    });

    var overlay = document.querySelector(SELECTORS.overlay);
    if (overlay && !overlay.dataset.pmBound) {
      overlay.dataset.pmBound = 'true';
      overlay.addEventListener('click', closeAllDrawers);
    }
  }

  function initHeader() {
    var header = document.querySelector('[data-pm-header]');
    if (!header) return;
    var lastY = Math.max(0, window.scrollY);
    var ticking = false;
    var update = function () {
      var currentY = Math.max(0, window.scrollY);
      var delta = currentY - lastY;
      header.classList.toggle('is-scrolled', currentY > 12);
      if (!document.body.classList.contains('pm-drawer-open')) {
        if (currentY > 150 && delta > 5) header.classList.add('is-hidden');
        if (currentY < 90 || delta < -5) header.classList.remove('is-hidden');
      }
      lastY = currentY;
      ticking = false;
    };
    var requestUpdate = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    };
    requestUpdate();
    window.addEventListener('scroll', requestUpdate, { passive: true });

    var announcement = document.querySelector('[data-pm-announcement]');
    if (!announcement || announcement.dataset.rotate !== 'true') return;
    var messages = all('[data-pm-announcement-message]', announcement);
    if (messages.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var current = 0;
    window.setInterval(function () {
      messages[current].classList.remove('is-active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('is-active');
    }, Number(announcement.dataset.interval || 5000));
  }

  function closeSearch() {
    var searchPanel = document.querySelector('.js-box-search');
    var searchRoot = searchPanel && searchPanel.closest('.search-full-destop');
    var searchBackdrop = document.querySelector('.bg_search_box');
    if (searchPanel) {
      searchPanel.classList.remove('active');
      searchPanel.setAttribute('aria-hidden', 'true');
    }
    if (searchRoot) {
      searchRoot.classList.remove('is-active');
      searchRoot.setAttribute('aria-hidden', 'true');
      searchRoot.setAttribute('inert', '');
    }
    if (searchBackdrop) searchBackdrop.classList.remove('active');
    all('.js-search-destop').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
    document.body.classList.remove('activedestop');
    syncBodyLock();
  }

  function openSearch() {
    var searchPanel = document.querySelector('.js-box-search');
    var searchRoot = searchPanel && searchPanel.closest('.search-full-destop');
    var searchBackdrop = document.querySelector('.bg_search_box');
    closeAllDrawers();
    closeMinicart();
    if (searchPanel) {
      searchPanel.classList.add('active');
      searchPanel.setAttribute('aria-hidden', 'false');
    }
    if (searchRoot) {
      searchRoot.classList.add('is-active');
      searchRoot.setAttribute('aria-hidden', 'false');
      searchRoot.removeAttribute('inert');
    }
    if (searchBackdrop) searchBackdrop.classList.add('active');
    all('.js-search-destop').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'true'); });
    document.body.classList.add('activedestop');
    syncBodyLock();
    window.setTimeout(function () {
      var input = searchPanel && searchPanel.querySelector('input[type="search"]');
      if (input) input.focus();
    }, 50);
  }

  function closeMinicart() {
    var minicart = document.querySelector('.js-minicart');
    var minicartBackdrop = document.querySelector('.bg-minicart');
    if (minicart) {
      minicart.classList.remove('active');
      minicart.setAttribute('aria-hidden', 'true');
      minicart.setAttribute('inert', '');
    }
    if (minicartBackdrop) minicartBackdrop.classList.remove('active');
    all('.js-call-minicart').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'false'); });
    syncBodyLock();
  }

  function openMinicart() {
    var minicart = document.querySelector('.js-minicart');
    var minicartBackdrop = document.querySelector('.bg-minicart');
    closeAllDrawers();
    closeSearch();
    if (minicart) {
      minicart.classList.add('active');
      minicart.setAttribute('aria-hidden', 'false');
      minicart.removeAttribute('inert');
    }
    if (minicartBackdrop) minicartBackdrop.classList.add('active');
    all('.js-call-minicart').forEach(function (trigger) { trigger.setAttribute('aria-expanded', 'true'); });
    syncBodyLock();
    window.setTimeout(function () {
      var closeButton = minicart && minicart.querySelector('.close-mini-cart');
      if (closeButton) closeButton.focus();
    }, 50);
  }

  function initLegacyBridges() {
    if (document.documentElement.dataset.pmOverlayBound) return;
    document.documentElement.dataset.pmOverlayBound = 'true';

    document.addEventListener('click', function (event) {
      var searchTrigger = event.target.closest('.js-search-destop');
      if (searchTrigger) {
        event.preventDefault();
        openSearch();
        return;
      }

      var cartTrigger = event.target.closest('.js-call-minicart');
      if (cartTrigger) {
        event.preventDefault();
        openMinicart();
        return;
      }

      if (event.target.closest('.js-drawer-close') || event.target.closest('.bg_search_box')) closeSearch();
      if (event.target.closest('.close-mini-cart') || event.target.closest('.bg-minicart')) closeMinicart();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeSearch();
        closeMinicart();
        return;
      }
      var activeOverlay = document.querySelector('.search-full-destop.is-active, .js-minicart.active');
      trapTab(event, activeOverlay);
    });
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      var args = arguments;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function definePredictiveSearch() {
    if (!window.customElements || customElements.get('premium-predictive-search')) return;

    function PremiumPredictiveSearch() {
      return Reflect.construct(HTMLElement, [], PremiumPredictiveSearch);
    }
    PremiumPredictiveSearch.prototype = Object.create(HTMLElement.prototype);
    PremiumPredictiveSearch.prototype.constructor = PremiumPredictiveSearch;
    Object.setPrototypeOf(PremiumPredictiveSearch, HTMLElement);

    PremiumPredictiveSearch.prototype.connectedCallback = function () {
      var element = this;
      element.input = element.querySelector('input[type="search"]');
      element.results = element.querySelector('[data-pm-predictive-results]');
      if (!element.input || !element.results || element.dataset.pmBound) return;
      element.dataset.pmBound = 'true';

      element.input.addEventListener('input', debounce(function () {
        var term = element.input.value.trim();
        if (term.length < 2) {
          element.results.innerHTML = '';
          element.input.setAttribute('aria-expanded', 'false');
          return;
        }
        element.getResults(term);
      }, 220));
    };

    PremiumPredictiveSearch.prototype.getResults = function (term) {
      var element = this;
      var url = element.dataset.url + '?q=' + encodeURIComponent(term) +
        '&section_id=predictive-search&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last';
      element.setAttribute('aria-busy', 'true');

      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Predictive search request failed');
          return response.text();
        })
        .then(function (markup) {
          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var section = parsed.querySelector('#shopify-section-predictive-search');
          element.results.innerHTML = section ? section.innerHTML : '';
          element.input.setAttribute('aria-expanded', element.results.textContent.trim() ? 'true' : 'false');
        })
        .catch(function () {
          element.results.innerHTML = '';
          element.input.setAttribute('aria-expanded', 'false');
        })
        .finally(function () {
          element.removeAttribute('aria-busy');
        });
    };

    customElements.define('premium-predictive-search', PremiumPredictiveSearch);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = precision == null ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';
    var parts = (Number(number) / 100).toFixed(precision).split('.');
    parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[0] + (parts[1] ? decimal + parts[1] : '');
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, format);
    }
    var moneyFormat = format || '{{amount}}';
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return (Number(cents) / 100).toLocaleString(undefined, { style: 'currency', currency: window.shop_currency || 'PKR' });
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }
    return moneyFormat.replace(match[0], value);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function shopRoute(path) {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + String(path).replace(/^\//, '');
  }

  function updateCartCounts(count) {
    all('.enj-cartcount').forEach(function (counter) {
      counter.textContent = count;
      counter.classList.toggle('hidden-count', count === 0 && counter.classList.contains('pm-cart-count'));
    });
    all('.js-call-minicart').forEach(function (trigger) {
      trigger.setAttribute('aria-label', 'Cart with ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function renderPremiumCart(cart) {
    var container = document.querySelector('.enj-minicart-ajax');
    updateCartCounts(cart.item_count || 0);
    if (!container) return;

    if (!cart.items || !cart.items.length) {
      container.innerHTML = '<div class="list_product_minicart empty"><div class="empty-product_minicart"><p>Your bag is currently empty.</p><a class="to-cart" href="' + escapeHtml(shopRoute('collections/all')) + '">Continue shopping</a></div></div>';
      return;
    }

    var items = cart.items.map(function (item, index) {
      var properties = item.properties || {};
      var propertiesHtml = Object.keys(properties).filter(function (key) {
        return key.charAt(0) !== '_' && properties[key] != null && String(properties[key]).trim() !== '';
      }).map(function (key) {
        return '<span class="ajaxcart__product-meta">' + escapeHtml(key) + ': ' + escapeHtml(properties[key]) + '</span>';
      }).join('');
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<span class="ajaxcart__product-meta">' + escapeHtml(item.variant_title) + '</span>'
        : '';
      var image = item.image
        ? '<img src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.product_title) + '" width="88" height="110" loading="lazy">'
        : '';
      var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;

      return '<ol class="minicart_item"><li>' +
        '<div class="thumb_img_cartmini"><a href="' + escapeHtml(item.url) + '">' + image + '</a></div>' +
        '<div class="product-detail"><h3 class="product_name_mini"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h3>' +
        variant + propertiesHtml +
        '<div class="product_info"><span>Qty: ' + escapeHtml(item.quantity) + '</span><span>' + formatMoney(linePrice, window.money_format) + '</span></div></div>' +
        '<div class="produc_remove"><button class="remove-product" type="button" data-line="' + (index + 1) + '" aria-label="Remove ' + escapeHtml(item.product_title) + '">×</button></div>' +
        '</li></ol>';
    }).join('');

    container.innerHTML = '<div class="prod"><div class="product-cart">' + items + '</div></div>' +
      '<div class="sub-total"><span class="total-title">Subtotal</span><span class="total-price">' + formatMoney(cart.total_price, window.money_format) + '</span></div>' +
      '<div class="action-checkout"><a class="button-viewcart" href="' + escapeHtml(shopRoute('cart')) + '">View bag</a><a class="button-checkout" href="' + escapeHtml(shopRoute('checkout')) + '">Checkout</a></div>';
  }

  function setCartMessage(form, message, isError) {
    var output = form.querySelector('[data-pm-product-status], [data-pm-cart-message]');
    if (!output) {
      output = document.createElement('p');
      output.className = 'pm-cart-message';
      output.dataset.pmCartMessage = '';
      output.setAttribute('role', 'status');
      form.appendChild(output);
    }
    output.textContent = message || '';
    output.classList.toggle('is-error', Boolean(isError));
  }

  function initPremiumCart() {
    if (document.documentElement.dataset.pmCartBound) return;
    document.documentElement.dataset.pmCartBound = 'true';

    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      event.preventDefault();

      var button = event.submitter || form.querySelector('[type="submit"]');
      var label = button && (button.querySelector('[data-pm-add-label]') || button);
      var originalText = label ? label.textContent : '';
      var wasDisabled = button ? button.disabled : false;
      if (button) button.disabled = true;
      if (label) label.textContent = 'Adding…';
      setCartMessage(form, '', false);

      fetch(shopRoute('cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
        credentials: 'same-origin'
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');
          return fetch(shopRoute('cart.js'), { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
        });
      }).then(function (response) {
        if (!response.ok) throw new Error('Your bag could not be refreshed.');
        return response.json();
      }).then(function (cart) {
        renderPremiumCart(cart);
        setCartMessage(form, 'Added to your bag.', false);
        openMinicart();
      }).catch(function (error) {
        setCartMessage(form, error.message || 'This item could not be added. Please try again.', true);
      }).finally(function () {
        if (button) button.disabled = wasDisabled;
        if (label) label.textContent = originalText;
      });
    });

    document.addEventListener('click', function (event) {
      var removeButton = event.target.closest('.js-minicart .remove-product');
      if (!removeButton) return;
      event.preventDefault();
      removeButton.disabled = true;
      fetch(shopRoute('cart/change.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: Number(removeButton.dataset.line), quantity: 0 }),
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('The item could not be removed.');
        return response.json();
      }).then(renderPremiumCart).catch(function () {
        removeButton.disabled = false;
      });
    });
  }

  function initMediaZoom() {
    if (document.documentElement.dataset.pmMediaZoomBound) return;
    document.documentElement.dataset.pmMediaZoomBound = 'true';

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-pm-media-zoom]');
      if (trigger) {
        var productRoot = trigger.closest('[data-pm-product]');
        var dialog = productRoot && productRoot.querySelector('[data-pm-media-dialog]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        event.preventDefault();
        var image = dialog.querySelector('[data-pm-media-dialog-image]');
        image.src = trigger.href;
        image.alt = trigger.dataset.mediaAlt || '';
        dialog.showModal();
        var closeButton = dialog.querySelector('[data-pm-media-close]');
        if (closeButton) closeButton.focus();
        return;
      }

      var closeButton = event.target.closest('[data-pm-media-close]');
      if (closeButton) {
        var openDialog = closeButton.closest('dialog');
        if (openDialog && openDialog.open) openDialog.close();
        return;
      }

      if (event.target.matches && event.target.matches('[data-pm-media-dialog][open]')) event.target.close();
    });
  }

  function initSizeCharts(context) {
    all('[data-pm-size-chart-dialog]', context).forEach(function (dialog) {
      if (dialog.dataset.pmBound) return;
      dialog.dataset.pmBound = 'true';
      var productRoot = dialog.closest('[data-pm-product]') || document;
      var triggers = all('[data-pm-size-chart-open]', productRoot);
      var tabs = all('[data-pm-size-chart-tab]', dialog);
      var panels = all('[data-pm-size-chart-panel]', dialog);

      function selectPanel(key, moveFocus) {
        tabs.forEach(function (tab) {
          var selected = tab.dataset.pmSizeChartTab === key;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          if (selected && moveFocus) tab.focus();
        });
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.pmSizeChartPanel !== key;
        });
      }

      triggers.forEach(function (trigger) {
        if (trigger.dataset.pmSizeChartBound) return;
        trigger.dataset.pmSizeChartBound = 'true';
        trigger.addEventListener('click', function () {
          dialog.pmReturnFocus = trigger;
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
          document.body.classList.add('pm-size-chart-open');
          var selectedTab = dialog.querySelector('[data-pm-size-chart-tab][aria-selected="true"]');
          var closeButton = dialog.querySelector('[data-pm-size-chart-close]');
          if (closeButton) closeButton.focus();
          else if (selectedTab) selectedTab.focus();
        });
      });

      all('[data-pm-size-chart-close]', dialog).forEach(function (button) {
        button.addEventListener('click', function () {
          if (typeof dialog.close === 'function') dialog.close();
          else {
            dialog.removeAttribute('open');
            document.body.classList.remove('pm-size-chart-open');
            if (dialog.pmReturnFocus && document.contains(dialog.pmReturnFocus)) dialog.pmReturnFocus.focus();
          }
        });
      });

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { selectPanel(tab.dataset.pmSizeChartTab, false); });
        tab.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          var nextIndex = (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          selectPanel(tabs[nextIndex].dataset.pmSizeChartTab, true);
        });
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && typeof dialog.close === 'function') dialog.close();
      });
      dialog.addEventListener('close', function () {
        document.body.classList.remove('pm-size-chart-open');
        if (dialog.pmReturnFocus && document.contains(dialog.pmReturnFocus)) dialog.pmReturnFocus.focus();
      });
    });
  }

  function initProductGallery(root) {
    var gallery = root && root.querySelector('[data-pm-gallery]');
    if (!gallery || gallery.dataset.pmBound) return;
    gallery.dataset.pmBound = 'true';
    var slides = all('[data-pm-gallery-slide]', gallery);
    var thumbs = all('[data-pm-gallery-thumb]', gallery);
    var currentLabel = gallery.querySelector('[data-pm-gallery-current]');
    var currentIndex = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));

    function activate(index) {
      if (!slides.length) return;
      currentIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === currentIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        slide.toggleAttribute('inert', !active);
        if (!active) all('video', slide).forEach(function (video) { video.pause(); });
      });
      thumbs.forEach(function (thumb, thumbIndex) {
        var active = thumbIndex === currentIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        thumb.setAttribute('tabindex', active ? '0' : '-1');
        if (active && thumbIndex > 0) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
      if (currentLabel) currentLabel.textContent = String(currentIndex + 1).padStart(2, '0');
    }

    root.pmActivateMedia = function (mediaId) {
      var index = slides.findIndex(function (slide) { return String(slide.dataset.mediaId) === String(mediaId); });
      if (index >= 0) activate(index);
    };

    thumbs.forEach(function (thumb, index) {
      thumb.addEventListener('click', function () { activate(index); });
    });
    var previous = gallery.querySelector('[data-pm-gallery-prev]');
    var next = gallery.querySelector('[data-pm-gallery-next]');
    if (previous) previous.addEventListener('click', function () { activate(currentIndex - 1); });
    if (next) next.addEventListener('click', function () { activate(currentIndex + 1); });
    gallery.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      activate(currentIndex + (event.key === 'ArrowRight' ? 1 : -1));
      if (thumbs[currentIndex]) thumbs[currentIndex].focus();
    });
    activate(currentIndex);
  }

  function initProduct(root) {
    if (!root || root.dataset.pmBound) return;
    root.dataset.pmBound = 'true';
    initProductGallery(root);
    var dataNode = root.querySelector('[data-pm-product-json]');
    var form = root.querySelector('form[action*="/cart/add"]');
    if (!dataNode || !form) return;

    var product;
    try { product = JSON.parse(dataNode.textContent); } catch (error) { return; }
    var variants = product.variants || [];
    var selected = all('[data-pm-option-group]', root).map(function (group) {
      var active = group.querySelector('[data-pm-option-value].is-selected');
      return active ? active.dataset.value : '';
    });
    var idInput = form.querySelector('[name="id"]');
    var addButton = form.querySelector('[data-pm-add-to-cart]');
    var price = root.querySelector('[data-pm-price]');
    var comparePrice = root.querySelector('[data-pm-compare-price]');
    var saleBadge = root.querySelector('[data-pm-sale-badge]');
    var saleLabel = root.querySelector('[data-pm-sale-label]');
    var status = root.querySelector('[data-pm-product-status]');
    var sku = root.querySelector('[data-pm-sku]');
    var availability = root.querySelector('[data-pm-availability]');
    var availabilityLabel = root.querySelector('[data-pm-availability-label]');
    var mobilePrice = root.querySelector('[data-pm-mobile-price]');
    var mobileAdd = root.querySelector('[data-pm-mobile-add]');
    var stockNotice = root.querySelector('[data-pm-stock-notice]');
    var stockLabel = root.querySelector('[data-pm-stock-label]');
    var stockThreshold = Number(stockNotice && stockNotice.dataset.threshold || 0);
    var stockEnabled = Boolean(stockNotice && stockNotice.dataset.enabled === 'true');
    var moneyFormat = root.dataset.moneyFormat || window.money_format || 'Rs. {{amount}}';
    var customToggle = form.querySelector('[data-pm-custom-toggle]');
    var customPanel = form.querySelector('[data-pm-measurements]');
    var customSizeButton = form.querySelector('[data-pm-custom-size-button]');
    var buyNow = form.querySelector('[data-pm-buy-now]');

    function findVariant() {
      return variants.find(function (variant) {
        return variant.options.every(function (value, index) { return String(value) === String(selected[index]); });
      });
    }

    function updateAvailability() {
      all('[data-pm-option-group]', root).forEach(function (group, groupIndex) {
        all('[data-pm-option-value]', group).forEach(function (button) {
          var possible = selected.slice();
          possible[groupIndex] = button.dataset.value;
          var available = variants.some(function (variant) {
            return variant.available && variant.options.every(function (value, index) {
              return index === groupIndex || String(value) === String(possible[index]);
            }) && String(variant.options[groupIndex]) === String(button.dataset.value);
          });
          button.classList.toggle('is-unavailable', !available);
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
      });
    }

    function updateMedia(variant) {
      if (!variant || !variant.featured_media) return;
      if (typeof root.pmActivateMedia === 'function') {
        root.pmActivateMedia(variant.featured_media.id);
        return;
      }
      var media = root.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
      if (media && window.matchMedia('(max-width: 989px)').matches) {
        media.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    function updateStock(variant) {
      if (!stockNotice) return;
      var quantity = Number(variant && variant.inventory_quantity || 0);
      var tracked = Boolean(variant && variant.inventory_management);
      var show = stockEnabled && variant && variant.available && tracked && quantity > 0 && quantity <= stockThreshold;
      stockNotice.hidden = !show;
      if (stockLabel) stockLabel.textContent = show ? 'Only ' + quantity + ' left in this option' : '';
    }

    function update() {
      var variant = findVariant();
      all('[data-pm-option-group]', root).forEach(function (group, index) {
        var label = group.querySelector('[data-pm-selected-value]');
        if (label) label.textContent = group.querySelector('[data-pm-custom-size-button]') && customToggle && customToggle.checked ? 'Custom' : selected[index] || '';
      });

      if (variant) {
        if (idInput) idInput.value = variant.id;
        if (price) price.innerHTML = formatMoney(variant.price, moneyFormat);
        if (mobilePrice) mobilePrice.innerHTML = formatMoney(variant.price, moneyFormat);
        if (comparePrice) {
          comparePrice.innerHTML = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, moneyFormat) : '';
          comparePrice.hidden = !(variant.compare_at_price > variant.price);
        }
        if (saleBadge) {
          var onSale = variant.compare_at_price > variant.price;
          var saving = onSale ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
          saleBadge.hidden = !onSale;
          if (saleLabel) saleLabel.textContent = onSale ? 'Save ' + saving + '%' : '';
        }
        if (sku) sku.textContent = variant.sku || '';
        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.querySelector('[data-pm-add-label]').textContent = variant.available ? addButton.dataset.availableText : addButton.dataset.soldOutText;
        }
        if (mobileAdd) {
          mobileAdd.disabled = !variant.available;
          mobileAdd.querySelector('[data-pm-add-label]').textContent = variant.available ? mobileAdd.dataset.availableText : mobileAdd.dataset.soldOutText;
        }
        if (availability) availability.classList.toggle('is-unavailable', !variant.available);
        if (availabilityLabel) availabilityLabel.textContent = variant.available ? 'Available online' : 'Currently unavailable';
        if (status) {
          status.textContent = variant.available ? '' : addButton.dataset.soldOutText;
          status.classList.toggle('is-error', !variant.available);
        }
        updateStock(variant);
        var nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', nextUrl.toString());
        updateMedia(variant);
      } else {
        if (addButton) {
          addButton.disabled = true;
          addButton.querySelector('[data-pm-add-label]').textContent = addButton.dataset.unavailableText;
        }
        if (mobileAdd) {
          mobileAdd.disabled = true;
          mobileAdd.querySelector('[data-pm-add-label]').textContent = mobileAdd.dataset.unavailableText;
        }
        if (availability) availability.classList.add('is-unavailable');
        if (availabilityLabel) availabilityLabel.textContent = 'Select another option';
        if (status) {
          status.textContent = addButton.dataset.unavailableText;
          status.classList.add('is-error');
        }
        updateStock(null);
      }
      updateAvailability();
    }

    all('[data-pm-option-group]', root).forEach(function (group, groupIndex) {
      all('[data-pm-option-value]', group).forEach(function (button) {
        button.addEventListener('click', function () {
          selected[groupIndex] = button.dataset.value;
          all('[data-pm-option-value]', group).forEach(function (sibling) {
            sibling.classList.toggle('is-selected', sibling === button);
            sibling.setAttribute('aria-pressed', sibling === button ? 'true' : 'false');
          });
          if (group.querySelector('[data-pm-custom-size-button]') && customToggle && customToggle.checked) {
            customToggle.checked = false;
            updateCustomSizing();
          }
          update();
        });
      });
    });

    var quantity = form.querySelector('input[name="quantity"]');
    all('[data-pm-quantity]', form).forEach(function (button) {
      button.addEventListener('click', function () {
        var current = Number(quantity.value || 1);
        var delta = button.dataset.pmQuantity === 'plus' ? 1 : -1;
        quantity.value = Math.max(1, current + delta);
      });
    });

    if (customToggle && customPanel) {
      var updateCustomSizing = function () {
        customPanel.hidden = !customToggle.checked;
        if (buyNow) buyNow.hidden = customToggle.checked;
        if (customSizeButton) {
          customSizeButton.classList.toggle('is-selected', customToggle.checked);
          customSizeButton.setAttribute('aria-pressed', customToggle.checked ? 'true' : 'false');
          var sizeGroup = customSizeButton.closest('[data-pm-option-group]');
          all('[data-pm-option-value]', sizeGroup).forEach(function (button) {
            button.classList.toggle('is-selected', !customToggle.checked && button.dataset.value === selected[Number(sizeGroup.dataset.optionPosition) - 1]);
            button.setAttribute('aria-pressed', button.classList.contains('is-selected') ? 'true' : 'false');
          });
        }
        all('[data-pm-measurement]', customPanel).forEach(function (input) {
          input.disabled = !customToggle.checked;
          input.required = customToggle.checked && input.tagName === 'INPUT' && input.dataset.optional !== 'true';
          if (!customToggle.checked && input.tagName !== 'SELECT') input.value = '';
        });
      };
      customToggle.addEventListener('change', updateCustomSizing);
      if (customSizeButton) customSizeButton.addEventListener('click', function () {
        customToggle.checked = !customToggle.checked;
        updateCustomSizing();
        update();
        if (customToggle.checked) customPanel.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
      });
      updateCustomSizing();
    }

    update();
  }

  var recommendationsObserver;

  function loadRecommendations(section) {
    if (section.dataset.pmLoaded || section.children.length) return;
    section.dataset.pmLoaded = 'true';
    section.dataset.pmObserved = '';
    if (recommendationsObserver) recommendationsObserver.unobserve(section);

    fetch(section.dataset.pmRecommendationsUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then(function (text) {
        var html = new DOMParser().parseFromString(text, 'text/html');
        var incoming = html.querySelector('[data-pm-recommendations-url]');
        if (incoming && incoming.innerHTML.trim()) {
          section.innerHTML = incoming.innerHTML;
          initSecondaryCardImages(section);
          initMotion(section);
        }
      })
      .catch(function () {
        section.dataset.pmLoaded = '';
      });
  }

  function initRecommendations(context) {
    all('[data-pm-recommendations-url]', context).forEach(function (section) {
      if (section.dataset.pmLoaded || section.dataset.pmObserved || section.children.length) return;

      if (!('IntersectionObserver' in window)) {
        loadRecommendations(section);
        return;
      }

      if (!recommendationsObserver) {
        recommendationsObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadRecommendations(entry.target);
          });
        }, { rootMargin: '600px 0px', threshold: 0 });
      }

      section.dataset.pmObserved = 'true';
      recommendationsObserver.observe(section);
    });
  }

  function initCountdowns(context) {
    all('[data-pm-countdown]', context).forEach(function (countdown) {
      if (countdown.dataset.pmBound) return;
      countdown.dataset.pmBound = 'true';
      var mode = countdown.dataset.mode || 'deadline';
      var cycleSeconds = Math.max(60, Number(countdown.dataset.duration) || 21600);
      var cycleMilliseconds = cycleSeconds * 1000;
      var deadline;
      var storageKey = 'rawish:rolling-service-window:' + cycleSeconds;
      var saveRollingDeadline = function () {
        try { window.localStorage.setItem(storageKey, String(deadline)); } catch (error) { /* Storage can be unavailable in private contexts. */ }
      };
      if (mode === 'rolling') {
        try { deadline = Number(window.localStorage.getItem(storageKey)); } catch (error) { deadline = 0; }
        if (!Number.isFinite(deadline) || deadline <= Date.now() || deadline > Date.now() + cycleMilliseconds) {
          deadline = Date.now() + cycleMilliseconds;
          saveRollingDeadline();
        }
      } else {
        deadline = Date.parse(countdown.dataset.deadline || '');
        if (!Number.isFinite(deadline)) {
          countdown.hidden = true;
          return;
        }
      }

      var days = countdown.querySelector('[data-pm-countdown-days]');
      var hours = countdown.querySelector('[data-pm-countdown-hours]');
      var minutes = countdown.querySelector('[data-pm-countdown-minutes]');
      var seconds = countdown.querySelector('[data-pm-countdown-seconds]');
      var progress = countdown.querySelector('.pm-product-countdown__progress span');
      var interval;
      var pad = function (value) { return String(value).padStart(2, '0'); };
      var tick = function () {
        var remaining = deadline - Date.now();
        if (remaining <= 0) {
          if (mode === 'rolling') {
            deadline += (Math.floor(Math.abs(remaining) / cycleMilliseconds) + 1) * cycleMilliseconds;
            saveRollingDeadline();
            remaining = deadline - Date.now();
          } else {
            countdown.hidden = true;
            if (interval) window.clearInterval(interval);
            interval = null;
            return;
          }
        }
        var totalSeconds = Math.floor(remaining / 1000);
        if (days) days.textContent = pad(Math.floor(totalSeconds / 86400));
        if (hours) hours.textContent = pad(Math.floor(totalSeconds % 86400 / 3600));
        if (minutes) minutes.textContent = pad(Math.floor(totalSeconds % 3600 / 60));
        if (seconds) seconds.textContent = pad(totalSeconds % 60);
        if (progress && mode === 'rolling') {
          progress.style.transform = 'scaleX(' + Math.max(0, Math.min(1, remaining / cycleMilliseconds)) + ')';
        }
      };
      var stop = function () {
        if (!interval) return;
        window.clearInterval(interval);
        interval = null;
      };
      var start = function () {
        if (countdown.hidden || document.hidden || interval) return;
        tick();
        interval = window.setInterval(tick, 1000);
      };
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
      start();
    });
  }

  function initSort(context) {
    all('[data-pm-sort]', context).forEach(function (select) {
      if (select.dataset.pmBound) return;
      select.dataset.pmBound = 'true';
      select.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.assign(url.toString());
      });
    });
  }

  function initSecondaryCardImages(context) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    all('.pm-product-card', context).forEach(function (card) {
      var image = card.querySelector('[data-pm-secondary-image]');
      if (!image || image.dataset.pmSecondaryBound) return;
      image.dataset.pmSecondaryBound = 'true';
      var load = function () {
        if (image.dataset.pmSecondaryLoaded) return;
        image.dataset.pmSecondaryLoaded = 'true';
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        image.removeAttribute('data-srcset');
        image.removeAttribute('data-src');
      };
      card.addEventListener('pointerenter', load, { once: true, passive: true });
      card.addEventListener('focusin', load, { once: true });
    });
  }

  var revealObserver;
  var REVEAL_SELECTOR = [
    '.pm-section-heading',
    '.pm-category-card',
    '.pm-product-card',
    '.pm-editorial__media',
    '.pm-editorial__content',
    '.pm-campaign-card',
    '.pm-story__media',
    '.pm-story__content',
    '.pm-trust__item',
    '.pm-product-editorial__media',
    '.pm-product-editorial__content',
    '.pm-reviews__heading',
    '.pm-review-card',
    '.pm-footer__column'
  ].join(',');

  function reveal(element) {
    element.classList.add('is-visible');
    if (revealObserver) revealObserver.unobserve(element);
  }

  function initMotion(context) {
    if (!document.documentElement.classList.contains('pm-motion-capable')) {
      document.documentElement.classList.add('pm-page-entered');
      return;
    }
    if (!revealObserver && 'IntersectionObserver' in window) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    }
    all(REVEAL_SELECTOR, context).forEach(function (element) {
      if (element.dataset.pmRevealBound) return;
      element.dataset.pmRevealBound = 'true';
      element.classList.add('pm-reveal');
      if (element.matches('.pm-editorial__media, .pm-story__media, .pm-product-editorial__media')) element.classList.add('pm-reveal--media');
      if (element.matches('.pm-editorial__content, .pm-story__content, .pm-product-editorial__content')) element.classList.add('pm-reveal--content');
      var parent = element.parentElement;
      var index = parent ? Array.prototype.indexOf.call(parent.children, element) : 0;
      element.style.setProperty('--pm-reveal-delay', Math.min(Math.max(index, 0), 5) * 70 + 'ms');
      if (revealObserver) revealObserver.observe(element);
      else reveal(element);
    });
  }

  function init(context) {
    initDrawers(context || document);
    initSecondaryCardImages(context || document);
    initMotion(context || document);
    initSizeCharts(context || document);
    all('[data-pm-product]', context || document).forEach(initProduct);
    initRecommendations(context || document);
    initCountdowns(context || document);
    initSort(context || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    definePredictiveSearch();
    initHeader();
    if (document.body.dataset.premiumTemplate === 'true') {
      initLegacyBridges();
      initPremiumCart();
    }
    initMediaZoom();
    init(document);
    if (document.documentElement.classList.contains('pm-motion-capable')) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          document.documentElement.classList.add('pm-page-entered');
        });
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    var openDrawer = document.querySelector(SELECTORS.drawer + '.is-open');
    if (!openDrawer) return;
    if (event.key === 'Escape') {
      setDrawerState(openDrawer, false);
      return;
    }
    trapTab(event, openDrawer);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
